import { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";

// ── UPDATE THIS when user shares Calendly URL ──
const CALENDLY_URL = "https://calendly.com/ankush-finadore/30min";
// ───────────────────────────────────────────────

export default function ScheduleCallFAB() {
  const [ready, setReady] = useState(false);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    // Load Calendly widget CSS
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://assets.calendly.com/assets/external/widget.css";
    document.head.appendChild(link);

    // Load Calendly widget JS
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    script.onload = () => setReady(true);
    document.body.appendChild(script);

    return () => {
      document.head.removeChild(link);
      document.body.removeChild(script);
    };
  }, []);

  const openCalendly = () => {
    if (ready && window.Calendly) {
      window.Calendly.initPopupWidget({ url: CALENDLY_URL });
    } else {
      window.open(CALENDLY_URL, "_blank");
    }
  };

  return (
    <button
      onClick={openCalendly}
      data-testid="schedule-call-fab"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      title="Schedule a Call"
      style={{
        position: "fixed",
        bottom: 100,
        right: 28,
        zIndex: 8999,
        display: "flex",
        alignItems: "center",
        gap: 10,
        background: "var(--navy)",
        color: "white",
        border: "none",
        cursor: "pointer",
        borderRadius: 100,
        padding: hovered ? "13px 20px 13px 16px" : "13px",
        boxShadow: "0 4px 20px rgba(27,43,107,0.4)",
        fontFamily: "DM Sans, sans-serif",
        fontWeight: 600,
        fontSize: 14,
        transition: "all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)",
        overflow: "hidden",
        whiteSpace: "nowrap",
        justifyContent: "center",
      }}
    >
      <CalendarDays size={22} style={{ flexShrink: 0 }} />
      <span
        style={{
          maxWidth: hovered ? 140 : 0,
          opacity: hovered ? 1 : 0,
          overflow: "hidden",
          transition: "max-width 0.25s ease, opacity 0.2s ease",
        }}
      >
        Schedule a Call
      </span>
    </button>
  );
}
